module.exports = __webpack_public_path__ + "img/size.e8227aaf.png";